// extracted by mini-css-extract-plugin
export var active = "_dw-2";
export var recordingDot = "_dw-1";
export var recordingIndicator = "_dw-0";